import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const createDefaultCharge = async ({
    token,
    company_id,
}) => {

    try {
        const res = await axiosCreate.post('/charge/create/default', {
            company_id
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}